var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateBlock',{attrs:{"mod-class":"","content-class":"shop-contacts","title-page":"Наши контакты"}},[_c('div',{staticClass:"w-100 h-100 shop-page"},[_c('ShopHeader'),_c('div',{staticClass:"page__content container"},[_vm._v(" Тут будут наши контакты или что-то с этим связанное) ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }